/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Sample } from './Sample';
import {
    SampleFromJSON,
    SampleFromJSONTyped,
    SampleToJSON,
    SampleToJSONTyped,
} from './Sample';

/**
 * 
 * @export
 * @interface BusinessReportNetSalesTimeseriesResponse
 */
export interface BusinessReportNetSalesTimeseriesResponse {
    /**
     * 
     * @type {Array<Sample>}
     * @memberof BusinessReportNetSalesTimeseriesResponse
     */
    data: Array<Sample>;
}

/**
 * Check if a given object implements the BusinessReportNetSalesTimeseriesResponse interface.
 */
export function instanceOfBusinessReportNetSalesTimeseriesResponse(value: object): value is BusinessReportNetSalesTimeseriesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BusinessReportNetSalesTimeseriesResponseFromJSON(json: any): BusinessReportNetSalesTimeseriesResponse {
    return BusinessReportNetSalesTimeseriesResponseFromJSONTyped(json, false);
}

export function BusinessReportNetSalesTimeseriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReportNetSalesTimeseriesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SampleFromJSON)),
    };
}

export function BusinessReportNetSalesTimeseriesResponseToJSON(json: any): BusinessReportNetSalesTimeseriesResponse {
    return BusinessReportNetSalesTimeseriesResponseToJSONTyped(json, false);
}

export function BusinessReportNetSalesTimeseriesResponseToJSONTyped(value?: BusinessReportNetSalesTimeseriesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(SampleToJSON)),
    };
}

